import { Toast } from 'antd-mobile';
import { ReactNode } from 'react';

type ToastType = 'success' | 'fail' | 'loading';

/**
 * 显示成功提示
 * @param message 提示消息
 */
export const showSuccessToast = (
  message: string | undefined | ReactNode
): void => {
  Toast.show({
    icon: 'success',
    content: message,
    maskStyle: {
      zIndex: 9999
    }
  });
};

/**
 * 显示错误提示
 * @param message 提示消息
 * @param fallback 当message为空时的备用消息
 */
export const showErrorToast = (
  message: string | undefined | ReactNode,
  options?: { maskClickable?: boolean }
): void => {
  const { maskClickable } = options || {};
  Toast.show({
    icon: 'fail',
    content: message || '操作失败',
    ...(typeof maskClickable !== 'undefined' ? { maskClickable } : {}),
    maskStyle: {
      zIndex: 9999
    }
  });
};

/**
 * 显示通用Toast
 * @param type Toast类型
 * @param message 提示消息
 */
export const showToast = (type: ToastType, message: string): void => {
  Toast.show({
    icon: type,
    content: message
  });
};
